app.controller('CIFProfile-CTRL',
    ['$scope', '$http', '$window', '$timeout', '$q', '$filter',
    function ($scope, $http, $window, $timeout, $q, $filter) {

    $scope.CIFInvestor = {}
    $scope.clientURL = 'FileKYC/';
    $scope.chkquestionfatca = 2;
    $scope.back = function () {
        $window.location.href = "#/dashboard";
    }
    var allPromise = $q.all([
        $http({
            method: 'POST',
            url: 'service/client.svc/retrieveSession',
        }).then(function (data) {
            if (!data.data.d) {
                $http({
                    method: 'GET',
                    url: 'service/client.svc/SignOut',
                }).then(function (data) {
                    if (data.data.d == true) {
                        $window.location.href = "#/login";
                        $window.location.reload();
                    }
                }, function (error) { })
            }
            else
                $scope.currentUser = data.data.d;
        }, function (error) { }),
    ]);


    allPromise.then(function () {
        $http({
            method: 'GET',
            url: 'service/client.svc/getCIFDetail',
            cache : false
        }).then(function (data) {
            if (data.data.d != null) {
                var obj = data.data.d;
                $scope.CIFInvestor = data.data.d;
                console.log('data', $scope.CIFInvestor);
                

                console.log('Q',data.data.d.QuestionRDN);
                if(data.data.d.QuestionRDN=="1")
                     $scope.CIFInvestor.QuestionRDN = "BANK CENTRAL ASIA";

                if(data.data.d.QuestionRDN=="2")
                    $scope.CIFInvestor.QuestionRDN = "BANK MANDIRI";

                if(data.data.d.QuestionRDN=="3")
                    $scope.CIFInvestor.QuestionRDN = "BANK CIMB";

                if(data.data.d.QuestionRDN=="4")
                    $scope.CIFInvestor.QuestionRDN = "BANK RAKYAT INDONESIA (BRI)";

                $scope.filenameKTP = $scope.CIFInvestor.KTPFile;
                $scope.filenameFotoDiri = $scope.CIFInvestor.SelfieFile;
                $scope.filenameTandaTangan = $scope.CIFInvestor.TandaTanganFile;
                $scope.filenameNPWP = $scope.CIFInvestor.NPWPFile;
                $scope.filenameTabungan = $scope.CIFInvestor.BukuTabunganFile;

                if ($scope.filenameKTP) {

                    if (!$scope.filenameKTP.endsWith(".pdf")) {
                        $http({
                            method: 'GET',
                            url: 'FileKYC/'+ $scope.filenameKTP,
                            responseType: 'blob',

                        }).then(function (response) {
                            $scope.KTPFile = [];
                            $scope.KTPFile.push(response.data);
                        }, function (response) {
                            $scope.saveErrors = true;
                            $scope.errorMessages = {
                                text: 'File tidak ketemu atau terhapus dari server!!!',
                            };
                            $timeout(function () {
                                $scope.saveErrors = false;
                            }, 3000);
                        });
                    }
                };
                if ($scope.filenameFotoDiri) {

                    if (!$scope.filenameFotoDiri.endsWith(".pdf")) {
                        $http({
                            method: 'GET',
                            url: 'FileKYC/' + $scope.filenameFotoDiri,
                            responseType: 'blob',
                        }).then(function (response) {
                            $scope.fotodiriFile = [];
                            $scope.fotodiriFile.push(response.data);
                        }, function (response) {
                            $scope.saveErrors = true;
                            $scope.errorMessages = {
                                text: 'File tidak ketemu atau terhapus dari server!!!',
                            };
                            $timeout(function () {
                                $scope.saveErrors = false;
                            }, 3000);
                        });
                    }
                };
                if ($scope.filenameTandaTangan) {

                    if (!$scope.filenameTandaTangan.endsWith(".pdf")) {
                        $http({
                            method: 'GET',
                            url: 'FileKYC/'+ $scope.filenameTandaTangan,
                            responseType: 'blob',

                        }).then(function (response) {
                            $scope.tandatanganFile = [];
                            $scope.tandatanganFile.push(response.data);
                        }, function (response) {
                            $scope.saveErrors = true;
                            $scope.errorMessages = {
                                text: 'File tidak ketemu atau terhapus dari server!!!',
                            };
                            $timeout(function () {
                                $scope.saveErrors = false;
                            }, 3000);
                        });
                    }
                };

                if ($scope.filenameNPWP) {

                    if (!$scope.filenameNPWP.endsWith(".pdf")) {
                        $http({
                            method: 'GET',
                            url: 'FileKYC/' + $scope.filenameNPWP,
                            responseType: 'blob',

                        }).then(function (response) {
                            $scope.NPWPFile = [];
                            $scope.NPWPFile.push(response.data);
                        }, function (response) {
                            $scope.saveErrors = true;
                            $scope.errorMessages = {
                                text: 'File tidak ketemu atau terhapus dari server!!!',
                            };
                            $timeout(function () {
                                $scope.saveErrors = false;
                            }, 3000);
                        });
                    }
                };

                if ($scope.filenameTabungan) {

                    if (!$scope.filenameTabungan.endsWith(".pdf")) {
                        $http({
                            method: 'GET',
                            url: 'FileKYC/' + $scope.filenameTabungan,
                            responseType: 'blob',

                        }).then(function (response) {
                            $scope.TabunganFile = [];
                            $scope.TabunganFile.push(response.data);
                        }, function (response) {
                            $scope.saveErrors = true;
                            $scope.errorMessages = {
                                text: 'File tidak ketemu atau terhapus dari server!!!',
                            };
                            $timeout(function () {
                                $scope.saveErrors = false;
                            }, 3000);
                        });
                    }
                };

                if ($scope.CIFInvestor.Sex) {
                    if ($scope.CIFInvestor.Sex == 'Male') {
                        $scope.imgMale = "../img/svg/stepcheck.svg";
                    }

                    if ($scope.CIFInvestor.Sex == "Female") {
                        $scope.imgMale = "../img/svg/report-animate.svg";
                    }
                }

                if ($scope.CIFInvestor.FATCA1 == 'Tidak' || $scope.CIFInvestor.FATCA2 == 'Tidak' || $scope.CIFInvestor.FATCA3 == 'Tidak') {
                    $scope.chkquestionfatca = 1;
                }


                if ($scope.CIFInvestor.IsFinished == 1)
                {
                    $scope.active = "active current";
                }
            } // END IF data.data.d
        }, function (error) { });
    });

  
    $scope.logOff = function () {
        $http({
            method: 'POST',
            url: 'service/client.svc/logOff',
        }).then(function (data) {
            console.log(data);
            if (data.data.d == true) {
                $window.location.href = "#/login";
                $window.location.reload();
            }
        }, function (error) { })
    };

}]);